import russian from './locales/russian.js';

function Emitter() {
    const self = {
        listeners: {},
        on: (eventName, handler) => {
            if (self.listeners[eventName] === undefined)
                self.listeners[eventName] = [];
            self.listeners[eventName].push(handler);
        },
        emit: (eventName, ...args) => {
            if (self.listeners[eventName] !== undefined)
                self.listeners[eventName].forEach(handler => handler.apply(args));
        },
    };

    return self;
}

const emitter = new Emitter();

emitter.options = {
    image: {
        uploadURL: 'None',
        dropzoneOptions: {},
    },
    hideModules: {},
    paragraphSeparator: 'div',
    maxHeight: undefined,
    customModules: [],
    locale: russian,
};


function getLink(element) {
    let node = element;

    while (node) {
        if (node.tagName === 'A') {
            return node;
        }

        node = node.parentNode;
    }

    return null;
}

function isInList(node) {
    while (node) {
        if (node.tagName === 'OL' || node.tagName === 'UL') {
            return true;
        }

        node = node.parentNode;
    }

    return false;
}


emitter.utils = {
    getSelectedHtml() {
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        const clonedSelection = range.cloneContents();
        const div = document.createElement('div');
        div.appendChild(clonedSelection);
        return div.innerHTML;
    },
    getSelectedText() {
        const selection = window.getSelection();

        if (!selection.rangeCount)
            return '';

        const range = selection.getRangeAt(0);
        return range.toString();
    },
    getLinkHref() {
        const selection = window.getSelection();
        if (!selection.rangeCount)
            return '';

        const range = selection.getRangeAt(0);
        const nodeParent = range.startContainer.parentNode;

        const linkParent = getLink(nodeParent);
        if (linkParent !== null) {
            return linkParent.href;
        }

        return '';
    },
    isNodeInList() {
        const selection = window.getSelection();
        if (!selection.rangeCount)
            return false;

        const range = selection.getRangeAt(0);
        const nodeParent = range.startContainer.parentNode;

        return isInList(nodeParent);
    },
    isNodeStartOfList() {
        const selection = window.getSelection();
        if (!selection.rangeCount)
            return false;
        const range = selection.getRangeAt(0);
        const nodeParent = range.startContainer.parentNode;

        // если курсор в начале списка и нет выделения
        return isInList(nodeParent) && range.startOffset === 0 && range.endOffset === 0;
    },
};


export default emitter;
